import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-excel-to-pdf',
    imports: [],
    templateUrl: './blog-excel-to-pdf.component.html',
    styleUrl: './blog-excel-to-pdf.component.css'
})
export class BlogExcelToPdfComponent {

}
